import { useState } from 'react';
import type { ReportReason, ReportTargetType } from '@blackblack/shared';
import { api, errorMessage } from '../../lib/api';
import { useToast } from '../../state/toast';
import { Button, TextArea, cx } from '../../components/ui/primitives';
import { Sheet } from '../../components/ui/Sheet';
import styles from './report.module.css';

const REASONS: Array<{ id: ReportReason; label: string }> = [
  { id: 'spam', label: 'Spam of misleidend' },
  { id: 'harassment', label: 'Intimidatie of pesten' },
  { id: 'hate', label: 'Haatzaaiende inhoud' },
  { id: 'violence', label: 'Geweld of gevaarlijke acties' },
  { id: 'nudity', label: 'Naaktheid of seksuele inhoud' },
  { id: 'self_harm', label: 'Zelfbeschadiging' },
  { id: 'misinformation', label: 'Desinformatie' },
  { id: 'copyright', label: 'Auteursrecht / muziekrechten' },
  { id: 'other', label: 'Iets anders' },
];

const TARGET_LABEL: Record<ReportTargetType, string> = { video: 'video', user: 'account', comment: 'reactie', track: 'nummer', playlist: 'playlist' };

/** Report flow for any target type; feeds the moderation queue in the admin dashboard. */
export function ReportSheet({ targetType, targetId, onClose }: { targetType: ReportTargetType; targetId: string; onClose: () => void }) {
  const toast = useToast();
  const [reason, setReason] = useState<ReportReason | null>(null);
  const [details, setDetails] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!reason) return;
    setBusy(true);
    try {
      await api.post('/reports', { targetType, targetId, reason, details: details || undefined });
      toast('Bedankt — ons team bekijkt je melding', { tone: 'success' });
      onClose();
    } catch (e) {
      toast(errorMessage(e), { tone: 'error' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Sheet open onClose={onClose} title={`${TARGET_LABEL[targetType][0]!.toUpperCase()}${TARGET_LABEL[targetType].slice(1)} rapporteren`}>
      <div className={styles.wrap}>
        <p className={styles.lead}>Waarom rapporteer je deze {TARGET_LABEL[targetType]}?</p>
        <div className={styles.reasons} role="radiogroup">
          {REASONS.map((r) => (
            <button key={r.id} role="radio" aria-checked={reason === r.id} className={cx(styles.reason, reason === r.id && styles.selected)} onClick={() => setReason(r.id)}>
              {r.label}
            </button>
          ))}
        </div>
        {reason && <TextArea label="Toelichting (optioneel)" value={details} onChange={(e) => setDetails(e.target.value)} maxLength={1000} rows={3} />}
        <Button block disabled={!reason} loading={busy} onClick={submit}>
          Melding versturen
        </Button>
      </div>
    </Sheet>
  );
}
